import React from "react";
import { PageHeader } from "../components/pageheader";
import { TestimonialBlock } from "../components/testimonial";
import { Link } from "react-router-dom";
import Martin from "@/assets/images/martin-k.png";
import Hero1 from "@/assets/images/apps-hero1.jpg";
import Hero2 from "@/assets/images/apps-hero2.jpg";

/* Container */
const Container: React.FC<React.PropsWithChildren<{ className?: string }>> = ({
  className = "",
  children,
}) => (
  <div className={`mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8 ${className}`}>
    {children}
  </div>
);

export default function ServicesWebappsPage() {
  return (
    <section className="py-14 text-white">
      <Container>
        {/* Back link */}
        <Link
          to="/services"
          className="inline-flex items-center text-sm text-white/60 hover:text-white mb-6 transition"
        >
          ← Services
        </Link>

        <div className="mb-12">
          <h2 className="font-display text-4xl md:text-7xl mb-6">
            We build digital products that scale and perform
          </h2>
          <p className="text-lg md:text-2xl leading-7 md:leading-9 text-white/60">
            We build fast, accessible, and scalable digital experiences —
            whether that means full e-commerce solutions, or modern front-end
            applications powered by solid design systems and component
            architectures.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-10 md:gap-40 text-white/60 mb-10">
          {/* Left column */}
          <div className="space-y-6">
            <div>
              <h3 className="font-semibold text-white">Clients</h3>
              <ul className="space-y-1">
                <li>Kjell & Company</li>
                <li>Fitness24Seven</li>
                <li>Thule</li>
                <li>Öresundbron</li>
                <li>Ålö</li>
                <li>Spar Kjøp</li>
              </ul>
            </div>
          </div>

          {/* Right column */}
          <div className="space-y-6">
            <div>
              <h3 className="font-semibold  text-white">What we did</h3>
              <ul className="space-y-1">
                <li>UX/UI Design</li>
                <li>Architect</li>
                <li>CD/CI</li>
                <li>Backend Development</li>
                <li>Frontend Development</li>
                <li>PIM / Search Engine / ERP integrations</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Image */}
        <img src={Hero1} alt="Web & Apps" className="mb-10" />
        <div className="mb-8 text-lg md:text-2xl leading-7 md:leading-9 leading-relaxed w-full md:w-3/4 text-white/80">
          <p className="mb-8">
            Our teams blend design, engineering and conversion thinking. We
            obsess over performance, SEO, accessibility and maintainability, and
            we integrate seamlessly with your product teams and workflows.
          </p>
          <p className="mb-8">
            We believe great digital products are built through partnership —
            not handoffs. That’s why we work embedded with your teams, shaping
            roadmaps, leveling up workflows, and helping you move faster with
            more confidence. Every engagement is a chance to reduce complexity,
            strengthen your foundation, and leave you better equipped for
            whatever comes next.
          </p>
        </div>

        <div className="mb-8 text-lg md:text-2xl leading-7 md:leading-9 leading-relaxed w-full md:w-3/4 text-white/80">
          <p className="mb-8">
            For many organisations, the real challenge isn’t choosing a new
            platform — it’s making everything work together. We help teams
            navigate that complexity. Whether it’s business systems, PIM or CRM
            platforms, content management, e-commerce engines, custom
            integrations, access control systems, or native apps, we’re used to
            working across entire digital ecosystems.
          </p>
          <p>
            Our approach is technology-agnostic and partnership-driven: we embed
            with your teams, understand how your systems fit together, and build
            solutions that are fast, reliable and future-proof. If you’re
            looking for a development partner who can support your whole stack —
            not just one piece of it — we’re built for exactly that.
          </p>
        </div>
        {/* Testimonial */}
        <TestimonialBlock
          quote="In a very short space of time, BoldBraves's fresh ideas and visualisation of how to improve our e-commerce experience, made us see what our site could look like, inspiring us to push forward and deliver."
          author="Martin Knutson"
          role="Former CTO Kjell & Company"
          avatar={Martin}
        />
      </Container>
    </section>
  );
}
